import { map, sortBy } from 'lodash/fp';
import { createSelector } from 'reselect';
import { createAction } from '@mews/framework';
import { ApplicationState, BookingEngine, Option as OptionType } from '@mews-commander/types';
import { Option } from '@mews-commander/legacy-data-structures';
import moduleSelector from '../selector';
import prefix from '../prefix';
import { createEntitiesReducer, createBaseEntitySelectors, createEntitySelectorByServiceId } from './utils';

export const NAME = 'bookingEngine';

const BOOKING_ENGINE_LOADED = prefix('BOOKING_ENGINE_LOADED');

export const setBookingEngines = (entities: BookingEngine[]) => createAction(BOOKING_ENGINE_LOADED, { entities });

export const bookingEngineReducer = createEntitiesReducer({ FETCH_SUCCESS: BOOKING_ENGINE_LOADED });

export const [getBookingEngines] = createBaseEntitySelectors<ApplicationState, BookingEngine, typeof NAME>(
    moduleSelector,
    NAME
);

export const getBookingEnginesByServiceId = createEntitySelectorByServiceId(getBookingEngines);

export const getServiceBookingEnginesOptions = createSelector(
    getBookingEnginesByServiceId,
    (bookingEngines): Array<OptionType> => {
        const options = map(({ id, name }) => Option({ value: id, label: name }), bookingEngines);
        return sortBy('label', options);
    }
);
